var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"symbol",style:(("width: " + _vm.width + "px; height: " + _vm.height + "px")),attrs:{"src":require("../assets/symbol.svg"),"alt":"Vale Saúde Sempre"}})}
var staticRenderFns = []

export { render, staticRenderFns }